import { PortalConfig } from '../datasource/config'
import portal from './portal'

export default PortalConfig.fromJS(portal)
